import React, { useState } from "react";
import s from "./ListBoat.module.scss";
import { BoatList } from "./../../utils/boatList";
import { Link } from "react-router-dom";
export const ListBoat = () => {
  const [openList, setOpenList] = useState(null);

  function onOpenList(listId) {
    if (String(openList) === String(listId)) {
      return setOpenList(null);
    }
    return setOpenList(listId);
  }

  return (
    <div className={s.wrap}>
      <div className={s.boatList}>
        {BoatList.map((listItem) => {
          let classHeader = `${s.boatList_header} `;
          if (listItem.id === openList) classHeader += `${s.active}`;

          return (
            <div className={s.boatList_item} key={listItem.id}>
              <div
                className={classHeader}
                onClick={() => onOpenList(listItem.id)}
              >
                <div className={s.boatList_img}>
                  <img src={listItem.img}></img>
                </div>
                <div className={s.boatList_descrtption}>
                  <div className={s.boatList_descrtption__header}>
                    <div className={s.title}>
                      {listItem.title}
                    </div>
                    {/* <div className={s.price}>
                      {listItem.price}
                    </div> */}
                  </div>
                  <div className={s.boatList_info}>{listItem.description}</div>
                </div>
                <div className={s.boatList_control}>
                  <img src="/img/iconsArrowTop.svg"></img>
                </div>
              </div>
              <div className={s.boatList_main}>
                {listItem.id === openList &&
                  listItem.values.map((item) => {
                    return (
                      <div key={`${item.id}${item.title}`} className={s.boatItem}>
                        <div className={s.boatItem_img}>
                          <img src={item.img}></img>
                        </div>
                        <div className={s.boatItem_title}>{item.title}</div>
                        {/* <div className={s.boatItem_description}>{item.description}</div> */}
                        <Link
                          className={`${s.boatItem_btn} ${s.btn} ${s.btn_block}`}
                          to={`/${item.id}`}
                        >
                          {item.buttonText}
                        </Link>
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
